import styled from "styled-components";

const Hint = styled.span`
    margin-left: 5px;
    color: gray;
`;

export default Hint;
